import React from 'react'
import { Text } from '../../../../styles/reactnative'
import SettingChange from './SettingChange'
import EntryTime from '../../../components/PositionColumns/EntryTime'

export const columns = (mutate, usermodal) => {
	return [
		{
			title: 'PC코드',
			dataIndex: 'key',
			key: 'key',
			align: 'center',
			render: (text, record) => (
				<Text style={{ fontSize: 12 }}>{text}</Text>
			),
		},
		{
			title: '메모',
			dataIndex: 'memo',
			key: 'memo',
			align: 'center',
			render: (text, record) => <Text>{text}</Text>,
		},
		{
			title: '등록일',
			dataIndex: 'created_at',
			key: 'created_at',
			width: 180,
			align: 'center',
			render: (text, record) => <EntryTime time={text} />,
		},
		{
			title: '관리',
			dataIndex: 'action',
			key: 'action',
			align: 'center',
			render: (text, record) => (
				<SettingChange data={record} mutate={mutate} />
			),
		},
	]
}
